/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListPendingMessageResponse } from '../models/api-response-list-pending-message-response';
import { ApiResponsePagedResultPendingMessageResponse } from '../models/api-response-paged-result-pending-message-response';
import { ApiResponsePendingMessageResponse } from '../models/api-response-pending-message-response';
import { getMediaByMediaId } from '../fn/pending-messages/get-media-by-media-id';
import { GetMediaByMediaId$Params } from '../fn/pending-messages/get-media-by-media-id';
import { searchPendingMessages } from '../fn/pending-messages/search-pending-messages';
import { SearchPendingMessages$Params } from '../fn/pending-messages/search-pending-messages';
import { sendBulkPendingMessages } from '../fn/pending-messages/send-bulk-pending-messages';
import { SendBulkPendingMessages$Params } from '../fn/pending-messages/send-bulk-pending-messages';
import { updatePendingMessage } from '../fn/pending-messages/update-pending-message';
import { UpdatePendingMessage$Params } from '../fn/pending-messages/update-pending-message';


/**
 * Endpoints for managing pending messages requiring validation
 */
@Injectable({ providedIn: 'root' })
export class PendingMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updatePendingMessage()` */
  static readonly UpdatePendingMessagePath = '/v1/api/pending-messages/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePendingMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePendingMessage$Response(params: UpdatePendingMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePendingMessageResponse>> {
    return updatePendingMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePendingMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePendingMessage(params: UpdatePendingMessage$Params, context?: HttpContext): Observable<ApiResponsePendingMessageResponse> {
    return this.updatePendingMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePendingMessageResponse>): ApiResponsePendingMessageResponse => r.body)
    );
  }

  /** Path part for operation `sendBulkPendingMessages()` */
  static readonly SendBulkPendingMessagesPath = '/v1/api/pending-messages/send-bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendBulkPendingMessages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBulkPendingMessages$Response(params: SendBulkPendingMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPendingMessageResponse>> {
    return sendBulkPendingMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendBulkPendingMessages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBulkPendingMessages(params: SendBulkPendingMessages$Params, context?: HttpContext): Observable<ApiResponseListPendingMessageResponse> {
    return this.sendBulkPendingMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPendingMessageResponse>): ApiResponseListPendingMessageResponse => r.body)
    );
  }

  /** Path part for operation `searchPendingMessages()` */
  static readonly SearchPendingMessagesPath = '/v1/api/pending-messages/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPendingMessages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPendingMessages$Response(params: SearchPendingMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPendingMessageResponse>> {
    return searchPendingMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPendingMessages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPendingMessages(params: SearchPendingMessages$Params, context?: HttpContext): Observable<ApiResponsePagedResultPendingMessageResponse> {
    return this.searchPendingMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultPendingMessageResponse>): ApiResponsePagedResultPendingMessageResponse => r.body)
    );
  }

  /** Path part for operation `getMediaByMediaId()` */
  static readonly GetMediaByMediaIdPath = '/v1/api/pending-messages/media/{mediaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMediaByMediaId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaByMediaId$Response(params: GetMediaByMediaId$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getMediaByMediaId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMediaByMediaId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMediaByMediaId(params: GetMediaByMediaId$Params, context?: HttpContext): Observable<Blob> {
    return this.getMediaByMediaId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
